import axios from 'axios';
import { getToken } from '../../../../utils/auth';
import { xTenantId, currencyCode } from '../../../../consts';
import { CashierType } from '../../../../state/cashier';

const requestUrl = process.env.REACT_APP_BASE_AUTH_URL;

export const fetchSessionId = async (
  userProfileId: string,
  method: string | CashierType | undefined
): Promise<string> => {
  const token = getToken();
  const response = await axios.post(
    `${requestUrl}/endeavour-devcode/v1/user-profiles/${userProfileId}/launch/${method}`,
    { currencyCode },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Tenant-ID': xTenantId,
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.sessionContextId;
};

export const claimPromoBonus = async (
  userProfileId: string,
  bonusId: string,
  contributionAmount: number,
  tagId: string
): Promise<boolean> => {
  try {
    const response = await axios.post('/claim', {
      userProfileId,
      bonusId,
      contributionAmount,
      tagId,
    });

    return response.status === 200;
  } catch (error) {
    return false;
  }
};
